// auto generated in scripts/sync-initial-stats.ts, don't change manually

export const initialState = {
    userStore: { user: null, initialized: false },
    abContentSourcePath: '',
    configStore: {
        shouldUpdateConfig: true,
        cdnUrl: 'https://cdn.m2.ru',
        cdnBlocksPrefixUrl: 'https://cdn.m2.ru/assets/cms-data/json-master',
        appEnvironment: 'test',
        recaptcha: { siteKey: '6Lf3NMYUAAAAAOBNTKj3QV6NEVkMgF_Xe-C4eO1T' },
        features: [
            { name: 'test-root_config' },
            { name: 'remont-contest-reseller-leaderboard' },
            { name: 'remont-contractor-order-page' },
            { name: 'dc-alternative-birth-certificate' },
            { name: 'personal-area-verification-feed' },
            { name: 'sbr-linked-deals-tab' },
            { name: 'personal-area-company-verification' },
            { name: 'contract-kit-approve-by-bank' },
            { name: 'lk-management-redirect' },
            { name: 'auth-is-email-verification-required-prof' },
            { name: 'auth-is-advertising-agreement-required' },
            { name: 'lk-management-company-settings-security-sessions' },
            { name: 'lk-management-draft-companies-list' },
            { name: 'lk-management-developer-tariff-read' },
            { name: 'mortgage-management' },
            { name: 'mortgage-calculator-v2' },
            { name: 'personal-area-samolet-banner' },
            { name: 'lk-phone-modal' },
            { name: 'dc-deal-navigation' },
            { name: 'deal-ea-egrn' },
            { name: 'deal-widget-deal-access' },
            { name: 'deal-widget-egrn-details' },
            { name: 'deal-passport-recognition' },
            { name: 'm2pro-verification-available' },
            { name: 'guaranteed-deal-short-order-flow' },
            { name: 'alternative-electronic-mortgage-available' },
            { name: 'alternative-ddi-feature-available' },
            { name: 'vtb-login' },
            { name: 'personal-area-partner-modal' },
            { name: 'alternative-suburban-deals' },
            { name: 'yandex-captcha' },
            { name: 'dc-estate-approval' },
            { name: 'dc-estate-approval-auto-check' },
            { name: 'show-helpdesk-web-push' },
            { name: 'dc-widget-deal-meeting' },
            { name: 'deal-widget-deal-meeting' },
            { name: 'sbr-search-azs-id-modal' },
            { name: 'deal-do-banner-insurance-chmak' },
            { name: 'deal-meeting-distant-notice' },
            { name: 'crm-client-b2b-export' },
            { name: 'discovery-cookie_consent-test_accept' },
            { name: 'discovery-root_page-show' },
            { name: 'crm-order-support-widget' },
            { name: 'm2pro-best-offers' },
            { name: 'ereg-send_client_updates_to_platform' },
            { name: 'deal-deal_vtb_gateway-estate_approval_file' },
            { name: 'deal-deal_vtb_gateway-estate_approval_attribute' },
            { name: 'deal-deal_vtb_gateway-deal-online' },
            { name: 'deal-online-request-call' },
            { name: 'deal-deal_calendar-remote_deal_booking' },
            { name: 'deal-deal_calendar-integration_office_only' },
            { name: 'dc-widget-deal-meeting-interregional' },
            { name: 'deal-products-accreditive-enabled' },
            { name: 'deal-deal_online_v3-deal_data_bank_integration_enabled' },
            { name: 'deal-deal_online_v3-deal_calendar_integration_enabled' },
            { name: 'deal-deal_online_v3-use_m2_order_prefix_for_new_non_mortgage_meetings' },
            { name: 'deal-deal_online_v3-bonus_program' },
            { name: 'deal-deal_notification-guarantee_deal_reminder' },
            { name: 'platform-services-with-tariffs' },
            { name: 'deal-auto_create_deal_platform_from_deal_online_v2' },
            { name: 'deal-platform_release_15_august' },
            { name: 'pricing-integration-enabled' },
            { name: 'deal-platform_b2c-deal-platform-orders-view' },
        ],
        supportPhone: '+7 495 136‑28‑18',
        copyright:
            '© Метр квадратный, 2026. М2 — экосистема для поиска и покупки недвижимости, выбора ипотечных предложений, защиты и проведения сделки. Общество с ограниченной ответственностью «Экосистема недвижимости «Метр квадратный», ОГРН 1197746330132 Адрес: 127055, г. Москва, вн. тер. г. муниципальный округ Тверской, ул. Лесная, д. 43',
        backupSupportPhone: '+7 495 230‑00‑21',
        microAppsConfig: {
            yandexCaptcha: { clientKey: 'ysc1_ZCwu1WZhXtFRUBtDs1VJGA1YHYHcsIJqChyneOSK72da6e81' },
            applications: [
                {
                    applicationName: 'deal-online',
                    logger: { sentryDsn: ['https://0d1f6f1647294084bc954d53a2d393b1@sentry.m2.ru/205'] },
                },
                {
                    applicationName: 'deal-join',
                    logger: { sentryDsn: ['https://0d1f6f1647294084bc954d53a2d393b1@sentry.m2.ru/205'] },
                },
                {
                    applicationName: 'bank-decision',
                    logger: { sentryDsn: ['https://0d1f6f1647294084bc954d53a2d393b1@sentry.m2.ru/205'] },
                },
                {
                    applicationName: 'deal-landing',
                    logger: { sentryDsn: ['https://0d1f6f1647294084bc954d53a2d393b1@sentry.m2.ru/205'] },
                },
                {
                    applicationName: 'widget-deal-meeting',
                    logger: { sentryDsn: ['https://0d1f6f1647294084bc954d53a2d393b1@sentry.m2.ru/205'] },
                },
                {
                    applicationName: 'deal-management',
                    logger: { sentryDsn: ['https://0d1f6f1647294084bc954d53a2d393b1@sentry.m2.ru/205'] },
                },
                {
                    applicationName: 'm2pro',
                    logger: { sentryDsn: ['https://60c01d21118544e6be59448fc48b1376@sentry.m2.ru/175'] },
                },
                {
                    applicationName: 'personal-area',
                    logger: { sentryDsn: ['https://831865f4b39e404aa2dcb7e030e11f36@sentry.m2.ru/11'] },
                },
                {
                    applicationName: 'root',
                    logger: { sentryDsn: ['https://5d621caae0bd4476b6af418ed711758d@sentry.m2.ru/2'] },
                },
                {
                    applicationName: 'alternative',
                    logger: { sentryDsn: ['https://44e054afb82c414db6d51f33244e8312@sentry.m2.ru/113'] },
                },
                {
                    applicationName: 'deal-navigation',
                    logger: { sentryDsn: ['https://e0d91495142b458e8e9219cb1f8e526e@sentry.m2.ru/223'] },
                },
                {
                    applicationName: 'apartment-complex',
                    logger: { sentryDsn: ['https://4c0fe13557c64f38b6f20db0d4632b93@sentry.m2.ru/166'] },
                },
                {
                    applicationName: 'auth',
                    logger: { sentryDsn: ['https://8822e70a08e24189bd8f3d817cc70fd6@sentry.m2.ru/4'] },
                },
                {
                    applicationName: 'backstage',
                    logger: { sentryDsn: ['https://352803b5b6574b80ade9ac7776a03f02@sentry.m2.ru/101'] },
                },
                {
                    applicationName: 'billing',
                    logger: { sentryDsn: ['https://8adc9f776c1d4cfeaae2b2b12598b997@sentry.m2.ru/54'] },
                },
                {
                    applicationName: 'Re',
                    logger: { sentryDsn: ['https://767da377bc8949958120e5758beff2fa@sentry.m2.ru/128'] },
                },
                {
                    applicationName: 'contract-kit',
                    logger: { sentryDsn: ['https://8ae951f815b549aaa25d21962d548b8a@sentry.m2.ru/117'] },
                },
                {
                    applicationName: 'document-configurator',
                    logger: { sentryDsn: ['https://cfe7e411f9b94c3f96f16e208e1154f6@sentry.m2.ru/15'] },
                },
                {
                    applicationName: 'eregistration',
                    logger: { sentryDsn: ['https://7cb462d17d5242df890bcace0b8fb8c2@sentry.m2.ru/13'] },
                },
                {
                    applicationName: 'eregistration-platform-widget',
                    logger: { sentryDsn: ['https://22c753855d4d2a17658d734ce2abc88e@sentry.m2.ru/289'] },
                },
                {
                    applicationName: 'home',
                    logger: { sentryDsn: ['https://1dfe3535ce164dc2bc61c3ea8f17e456@sentry.m2.ru/8'] },
                },
                {
                    applicationName: 'individuals',
                    logger: { sentryDsn: ['https://926d71e9893b499d96f0f0c1ac0a6834@sentry.m2.ru/40'] },
                },
                {
                    applicationName: 'lk-management',
                    logger: { sentryDsn: ['https://555a9bd4f11c4b1eb88f74a7b4cfc96d@sentry.m2.ru/98'] },
                },
                {
                    applicationName: 'm2pro-commission',
                    logger: { sentryDsn: ['https://b80fb0b8747b49e096fed2bd8c8815e0@sentry.m2.ru/214'] },
                },
                {
                    applicationName: 'm2-pro-presentations',
                    logger: { sentryDsn: ['https://a7145ece9f2f43da9bd9727998d83aad@sentry.m2.ru/201'] },
                },
                {
                    applicationName: 'mortgage',
                    logger: { sentryDsn: ['https://6d751bd57b0941bab3cab85b97cef3d5@sentry.m2.ru/6'] },
                },
                {
                    applicationName: 'news',
                    logger: { sentryDsn: ['https://9866db9260da464292d753739c67d11b@sentry.m2.ru/112'] },
                },
                {
                    applicationName: 'partners-public',
                    logger: { sentryDsn: ['https://0a37234052a1487d8d534f9e5b402204@sentry.m2.ru/33'] },
                },
                {
                    applicationName: 'property-insurance',
                    logger: { sentryDsn: ['https://94228088746d4efa97e7f3e6b9be6a9d@sentry.m2.ru/35'] },
                },
                {
                    applicationName: 'real-estate-registry',
                    logger: { sentryDsn: ['https://0fd91fd118dc4f01ba23c199edade1e8@sentry.m2.ru/21'] },
                },
                {
                    applicationName: 'realty-appraisal',
                    logger: { sentryDsn: ['https://cd1026daca3f4945b6cbbbc4521762f7@sentry.m2.ru/14'] },
                },
                {
                    applicationName: 'remont-contest',
                    logger: { sentryDsn: ['https://33e67e1b9bf24829bf905e3a93d67ac3@sentry.m2.ru/193'] },
                },
                {
                    applicationName: 'remont',
                    logger: { sentryDsn: ['https://c8634690725e4f529942af556a365c46@sentry.m2.ru/19'] },
                },
                {
                    applicationName: 'remont-public',
                    logger: { sentryDsn: ['https://84f8a0353cda413eb1c2a305b876f2b9@sentry.m2.ru/146'] },
                },
                {
                    applicationName: 'secure-payment-service',
                    logger: { sentryDsn: ['https://10aeba3daa1044a3bc98f391fe3e7a3e@sentry.m2.ru/17'] },
                },
                {
                    applicationName: 'suburban',
                    logger: { sentryDsn: ['https://79a5c6b3aee349d5ae66cfe4bbdb1254@sentry.m2.ru/247'] },
                },
                {
                    applicationName: 'suburban-catalog',
                    logger: { sentryDsn: ['https://db998689cdb64542a739a91f76b1d8c6@sentry.m2.ru/248'] },
                },
                {
                    applicationName: 'ihc-brokerage',
                    logger: { sentryDsn: ['https://3a049ad76555136480ab56c79f148018@sentry.m2.ru/287'] },
                },
                {
                    applicationName: 'vacancy',
                    logger: { sentryDsn: ['https://60e7edaa510142038acb9c46e2fcb05e@sentry.m2.ru/9'] },
                },
                {
                    applicationName: 'chat',
                    logger: { sentryDsn: ['https://64565092a7324ddb947569678b1f2085@sentry.m2.ru/217'] },
                },
                {
                    applicationName: 'chat-templates',
                    logger: { sentryDsn: ['https://94e0cd8135f04e59b124769ede834228@sentry.m2.ru/253'] },
                },
                {
                    applicationName: 'moscow-object-verification',
                    logger: { sentryDsn: ['https://75f33bcc5f67b65fe11ee9aa3660b0df@sentry.m2.ru/270'] },
                },
                {
                    applicationName: 'crm-sales',
                    logger: { sentryDsn: ['https://07a25ff70d4d45ba5a7342bc807ed3fe@sentry.m2.ru/258'] },
                },
                {
                    applicationName: 'deal-platform',
                    logger: { sentryDsn: ['https://3a8d4f88089ed0ef340f10d26bd5b266@sentry.m2.ru/273'] },
                },
                {
                    applicationName: 'deal-online-platform',
                    logger: { sentryDsn: ['https://cfa8005cad4700fed679341f26cd6909@sentry.m2.ru/300'] },
                },
                {
                    applicationName: 'b2c-deal-platform-orders-view',
                    logger: { sentryDsn: ['https://2e047aa490fa9d7b2d86a229448c8b6c@sentry.m2.ru/308'] },
                },
            ],
        },
    },
    menuStore: {
        menu: {
            items: [
                {
                    id: '1',
                    displayName: 'Поиск',
                    dropdownMenu: [
                        {
                            id: '1',
                            displayName: 'Покупка недвижимости',
                            url: '/moskva/nedvizhimost/kupit-kvartiru/',
                            icon: 'm2-building',
                            iconColor: '#3216B5',
                        },
                        {
                            id: '2',
                            displayName: 'Аренда недвижимости',
                            url: '/moskva/nedvizhimost/snyat-kvartiru/',
                            icon: 'm2-chair',
                            iconColor: '#3216B5',
                        },
                        {
                            id: '3',
                            displayName: 'Новостройки',
                            url: '/moskva/novostroyki/',
                            icon: 'm2-building-multiple',
                            iconColor: '#3216B5',
                        },
                    ],
                },
                {
                    id: '11',
                    displayName: 'Ипотека',
                    path: '/ipoteka/',
                    icon: 'm2-percentage-circle',
                    iconColor: '#FF784B',
                },
                {
                    id: '2',
                    displayName: 'Сделка',
                    dropdownMenu: [
                        {
                            id: 'deal',
                            displayName: 'Покупка онлайн',
                            path: '/services/deal/',
                            icon: 'house-plus',
                            iconColor: '#B9B6C9',
                        },
                        {
                            id: '7',
                            displayName: 'Защита сделки',
                            path: '/services/guaranteed-deal/',
                            icon: 'm2-document-check',
                            iconColor: '#B9B6C9',
                        },
                        {
                            id: '1',
                            displayName: 'Проверка недвижимости',
                            path: '/services/proverka-yuridicheskoy-chistoty-kvartiry/',
                            icon: 'm2-house-checked',
                            iconColor: '#B9B6C9',
                        },
                        {
                            id: '2',
                            displayName: 'Расчёт стоимости недвижимости',
                            path: '/services/ocenka-stoimosti-kvartiry',
                            icon: 'm2-house-stroked',
                            iconColor: '#B9B6C9',
                        },
                        {
                            id: '3',
                            displayName: 'Страхование имущества',
                            path: '/services/strahovanie-imushchestva',
                            icon: 'shield-check',
                            iconColor: '#B9B6C9',
                        },
                    ],
                },
                {
                    id: '8',
                    displayName: 'Ремонт',
                    dropdownMenu: [
                        { id: '1', displayName: 'Ремонт под ключ', path: '/remont/' },
                        { id: '2', displayName: 'Предчистовая отделка', path: '/remont/white-box/' },
                        { id: '3', displayName: 'Дизайн-проект', path: '/remont/design-project/' },
                        { id: '4', displayName: 'Приемка квартиры', path: '/remont/priyemka-kvartiry/' },
                    ],
                },
                {
                    id: '3',
                    displayName: 'Партнёрам',
                    dropdownMenu: [
                        { id: '1', displayName: 'Агентам', path: '/rieltors' },
                        { id: '2', displayName: 'Застройщикам', path: '/developers' },
                    ],
                },
            ],
            partners: {
                default: {
                    id: 'samolet',
                    logo: 'https://cdn.m2.ru/assets/file-upload-server/79d4b22c91a9e7476efcd27c1c19305a.svg',
                    url: '/samolet/',
                },
                cds: {
                    id: 'cds',
                    logo: 'https://cdn.m2.ru/assets/file-upload-server/2967c9a3a2268d4067822c6edb678bb5.svg',
                    url: '/cds/',
                },
            },
        },
    },
    bundleTreeStore: {
        bundleTree: {
            routes: [
                { path: '/', exact: true, applicationName: 'home', availableForNotAuthorized: true },
                {
                    path: '(/login|/registration|/reset-password|/link-registration)',
                    applicationName: 'auth',
                    availableForNotAuthorized: true,
                },
                { path: '/mortgage', applicationName: 'mortgage', availableForNotAuthorized: true },
                { path: '/ipoteka', applicationName: 'mortgage', availableForNotAuthorized: true },
                { path: '/personal-area/services/guaranteed-deal', applicationName: 'guaranteed-deal' },
                {
                    path: '/personal-area/services/proverka-yuridicheskoy-chistoty-kvartiry',
                    applicationName: 'real-estate-registry',
                },
                {
                    path: '(/personal-area|/account|/employees|/affiliated-companies)',
                    applicationName: 'personal-area',
                },
                { path: '/management', applicationName: 'lk-management', availableForNotAuthorized: false },
                {
                    path: '/services/ocenka-stoimosti-kvartiry',
                    applicationName: 'realty-appraisal',
                    availableForNotAuthorized: true,
                },
                {
                    path: '/services/strahovanie-imushchestva',
                    applicationName: 'property-insurance',
                    availableForNotAuthorized: true,
                },
                {
                    path: '/services/payment-result',
                    applicationName: 'payment-result',
                    availableForNotAuthorized: true,
                },
                {
                    path: '/services/proverka-yuridicheskoy-chistoty-kvartiry',
                    applicationName: 'real-estate-registry',
                    availableForNotAuthorized: true,
                },
                {
                    path: '/services/guaranteed-deal',
                    applicationName: 'guaranteed-deal',
                    availableForNotAuthorized: true,
                },
                { path: '/secure-payment-service', applicationName: 'secure-payment-service' },
                { path: '/accounting', applicationName: 'accounting' },
                { path: '/contract-kit', applicationName: 'contract-kit', availableForNotAuthorized: false },
                { path: '/dbo-bro', applicationName: 'dbo-bro', availableForNotAuthorized: false },
                { path: '/helpers', applicationName: 'helpers', availableForNotAuthorized: false },
                {
                    path: '/professional-search',
                    applicationName: 'professional-search',
                    assetsUrl: '/search/manifests/zbs-search/',
                    availableForNotAuthorized: false,
                },
                {
                    path: '/offer-placement',
                    applicationName: 'offer-placement',
                    assetsUrl: '/search/manifests/offer-placement/',
                    availableForNotAuthorized: false,
                },
                {
                    path: '/favorites',
                    applicationName: 'favorites',
                    assetsUrl: '/search/manifests/favorites/',
                    availableForNotAuthorized: false,
                },
                {
                    path: '/remont/(account|manager|client|contractor|designer)',
                    applicationName: 'remont',
                    availableForNotAuthorized: false,
                },
                { path: '/remont', applicationName: 'remont-public', availableForNotAuthorized: true },
                {
                    path: '/document-configurator',
                    applicationName: 'document-configurator',
                    availableForNotAuthorized: true,
                },
                { path: '/eregistration', applicationName: 'eregistration', availableForNotAuthorized: false },
                { path: '/sdelka', applicationName: 'sdelka', availableForNotAuthorized: false },
                { path: '(/vacancies|/partners)', applicationName: 'vacancies', availableForNotAuthorized: true },
                { path: '/sbr', applicationName: 'sbr-public', availableForNotAuthorized: true },
                { path: '/developers', applicationName: 'partners-public', availableForNotAuthorized: true },
                { path: '(/advisor|/seaside)', applicationName: 'individuals-public', availableForNotAuthorized: true },
                { path: '/billing', applicationName: 'billing', availableForNotAuthorized: false },
                { path: '/vas', applicationName: 'temp-landings', availableForNotAuthorized: true },
            ],
        },
    },
    footerStore: {
        footer: {
            downloadAppQrCode: 'https://cdn.m2.ru/assets/file-upload-server/5f03bb1725f314b8c9e8f175437817b4.svg',
            top: [
                [
                    { name: 'О компании', href: '/about/', cdn: false, analytics: 'footerLinkAbout' },
                    { name: 'Вакансии', href: '/vacancies/', cdn: false, analytics: 'footerLinkVacancies' },
                    { name: 'ИТ-деятельность', href: '/it/', cdn: false, analytics: 'footerLinkIT' },
                    { name: 'Помощь', href: '/support/', cdn: false, analytics: 'footerLinkSupport' },
                    { name: 'Наши партнёры', href: '/partners/', cdn: false, analytics: 'footerLinkPartners' },
                    { name: 'М2 Медиа', href: '/media/', cdn: false, analytics: 'footerLinkNews' },
                    { name: 'Новости М2', href: '/pr/', cdn: false, analytics: 'footerLinkPr' },
                ],
                [
                    {
                        name: 'Правила оплаты',
                        href: '/assets/pdfs/oplata-onlain.pdf',
                        cdn: true,
                        analytics: 'footerLinkPaymentRules',
                    },
                    {
                        target: '_blank',
                        name: 'Закупки',
                        href: 'https://bidzaar.com/publicprofile/index/54eee136-f189-4823-8b5c-5dc58589d1d0',
                        cdn: false,
                        analytics: 'footerLinkTender',
                    },
                    {
                        name: 'Клиентские документы',
                        href: '/doc/clients/',
                        cdn: false,
                        analytics: 'footerLinkSoglasheniya',
                    },
                    {
                        name: 'Безопасность данных',
                        href: '/data-security/',
                        cdn: false,
                        analytics: 'footerLinkDataSecurity',
                    },
                ],
            ],
            middleLinks: [
                {
                    title: 'Частным лицам',
                    links: [
                        {
                            name: 'Новостройки',
                            href: '/moskva/novostroyki/',
                            analytics: 'footerLinkNovostroyki',
                            linkGenerationId: 'new-buildings',
                        },
                        { name: 'Ипотека', href: '/ipoteka/', analytics: 'footerLinkIpoteka' },
                        {
                            name: 'Ипотечный калькулятор',
                            href: '/ipoteka/calculator/',
                            analytics: 'footerLinkIpotechyjKalkulyator',
                        },
                        { name: 'Сделка', href: '/services/deal/', analytics: 'footerDeal' },
                        {
                            name: 'Защита сделки',
                            href: '/services/guaranteed-deal/',
                            analytics: 'footerGuaranteedDeal',
                        },
                        {
                            name: 'Проверка недвижимости',
                            href: '/services/proverka-yuridicheskoy-chistoty-kvartiry/',
                            analytics: 'footerLinkProverka',
                        },
                    ],
                },
                {
                    title: 'Риелторам и агентствам',
                    links: [
                        {
                            name: 'Новостройки',
                            href: '/moskva/novostroyki/',
                            analytics: 'footerLinkNovostroyki',
                            linkGenerationId: 'new-buildings',
                        },
                        { name: 'Ипотека', href: '/rieltoram/ipoteka/' },
                        { name: 'Сделка', href: '/rieltoram/online-sdelka/' },
                        { name: 'Сервис безопасных расчётов', href: '/rieltoram/sbr/' },
                        { name: 'Электронная регистрация', href: '/rieltoram/elreg/' },
                        { name: 'Защита сделки', href: '/rieltoram/guaranteed-deal/' },
                        {
                            name: 'Проверка недвижимости',
                            href: '/rieltoram/proverka/',
                            analytics: 'footerLinkProverka',
                        },
                        { name: 'Мероприятия', href: '/events/' },
                        { name: 'M2Pro Новостройки', href: '/rieltoram/m2pro-novostroyki/' },
                    ],
                },
                {
                    title: 'Партнёрам',
                    links: [
                        { name: 'Брокер ИЖС', href: '/brokerizhs/' },
                        { name: 'Электронная регистрация для ЮЛ', href: '/elektronnaya-registraciya-sdelok-yul/' },
                        { name: 'Безопасные расчёты для ЮЛ', href: '/elektronnaya-registraciya-sdelok-yul/' },
                    ],
                },
            ],
            socialLinks: [
                { name: 'ВКонтакте', icon: 'vk', href: 'https://vk.ru/metr_kvadratnyy' },
                { name: 'Telegram', icon: 'telegram', href: 'https://t.me/metrkvadratny/' },
                { name: 'Max', icon: 'max', href: 'https://max.ru/m2rieltor' },
            ],
            apps: [
                {
                    href: 'https://trk.mail.ru/c/htywr2?mt_gaid={mt_gaid}&mt_campaign=web_footer',
                    analytics: 'FooterLinkRuStore',
                    imgSrc: '/assets/file-upload-server/ae1d8607969769407f91a9897e61121b.svg',
                },
                {
                    href: 'https://trk.mail.ru/c/n9fk639?mt_gaid={mt_gaid}&mt_campaign=web_footer',
                    analytics: 'FooterLinkHuawei',
                    imgSrc: '/assets/file-upload-server/f24c8e5b58b995f37dc1afcb386456f6.svg',
                },
                {
                    href: 'https://trk.mail.ru/c/ygrxv6?mt_gaid={mt_gaid}&mt_campaign=web_footer',
                    analytics: 'FooterLinkGetApps',
                    imgSrc: '/assets/file-upload-server/d1531d4256a615f155f41b47c9696015.svg',
                },
                {
                    href: 'https://trk.mail.ru/c/gkklf3?mt_gaid=%7Bmt_gaid%7D&mt_campaign=web_footer',
                    analytics: 'FooterLinkGalaxy',
                    imgSrc: '/assets/file-upload-server/4dc08b404fc6f2c59c48afb176afe08f.svg',
                },
            ],
        },
    },
    layoutStore: {
        layoutConfig: {
            layouts: [
                { ref: 'empty' },
                { ref: 'empty-on-mobile', header: { hide: true }, sidebar: { show: true } },
                { ref: 'navbar-on-mobile', navbarOnMobile: { show: true }, chatsButtonOnMobile: { hide: true } },
                { ref: 'authorized', sidebar: { show: true } },
                { ref: 'lite', header: { sticky: false, filled: false, hideElementsDependOnAuthState: true } },
                { ref: 'default', header: { sticky: false, filled: false }, footer: { show: true } },
                { ref: 'authentication', header: { sticky: false, filled: false, hideAllElementsExceptLogo: true } },
            ],
            routes: [
                {
                    url: [
                        '^/personal-area/?$',
                        '^/personal-area/all-deals.*',
                        '^/personal-area/services/?$',
                        '^/deal-grant-access.*',
                    ],
                    layoutRef: 'navbar-on-mobile',
                },
                { url: ['^/account.*', '^/deal/orders/.+'], layoutRef: 'empty-on-mobile' },
                {
                    url: [
                        '^/login.*',
                        '^/registration.*',
                        '^/reset-password.*',
                        '^/link-registration.*',
                        '^/services/deal/join.*',
                        '^/services/deal/bank-decision.*',
                    ],
                    layoutRef: 'authentication',
                },
                {
                    url: [
                        '^/personal-area.*',
                        '^/deal-management.*',
                        '^/management.*',
                        '^/tarif-supersdelka.*',
                        '^/admin.*',
                        '^/partner(/.*)?$',
                        '^/secure-payment-service.*',
                        '^/remont/(account|manager|client(?!/webview)|contractor|designer|reseller)',
                        '^/remont/contest(/.*)?$',
                        '^/eregistration(?!(/remote-usb-signing)).*',
                        '^/moscow-object-verification.*',
                        '^/client-sign.*',
                        '^/sdelka.*',
                        '^/professional-search.*',
                        '^/offer-placement(?!(/public)).*',
                        '^/feed-statistic.*',
                        '^/favorites.*',
                        '^/saved-search.*',
                        '^/hidden-offers.*',
                        '^/employees.*',
                        '^/affiliated-companies.*',
                        '^/contract-kit.*',
                        '^/alternative.*',
                        '^/apartment-complex.*',
                        '^/m2-pro-commission-editor.*',
                        '^/m2-pro-commission.*',
                        '^/m2-pro(?!/presentations/.+)(/.*)?/?$',
                        '^/billing.*',
                        '^/(ipoteka|mortgage)(/partners|)/demand.*',
                        '^/(ipoteka|mortgage)/(list|dealonline|backoffice).*',
                        '^/services/real-estate-registry-lawyer(/.*)?$',
                        '^/services/legal-support-lawyer(/.*)?$',
                        '^/services/express-checkup-lawyer(/.*)?$',
                        '^/vl.*',
                        '^/suburban(/(manager|client(?!/webview)|contractor))',
                        '^/suburban-catalog.*',
                        '^/brokerage.*',
                        '^/rieltor/(clients|earn|academy)(/.*)?$',
                        '^/helpdesk.*',
                        '^/person.*',
                        '^/crm.*',
                        '^/deal(/.*)?$',
                        '^/deal-forbidden-page.*',
                        '^/deal-online-platform.*',
                        '^/subscription/management.*',
                    ],
                    layoutRef: 'authorized',
                },
                {
                    url: [
                        '^/ipoteka/avito',
                        '^/ipoteka-white',
                        '^/remont/house',
                        '^/remont/client/webview',
                        '^/suburban/client/webview',
                        '^/m2-pro/presentations/.+$',
                        '^/eregistration/remote-usb-signing',
                        '^/helpers',
                        '^/deal-landing',
                        '^/services/guaranteed-deal/orders/.+/payment/?$',
                    ],
                    layoutRef: 'empty',
                },
                { url: ['^/logout.*', '^/invoice.*'], layoutRef: 'lite' },
                { url: ['.+'], layoutRef: 'default' },
            ],
            hideUseDeskRoutes: ['^/chat.*', '^/m2-pro/presentations/.+$', '^/login/vtb.*'],
            hideCookieConsentRoutes: ['^/login/vtb.*'],
        },
    },
    sidebarStore: { sidebar: { main: [], footer: [] } },
    headerStore: {
        header: {
            items: [
                {
                    id: 'DEFAULT',
                    displayName: 'Частным лицам',
                    displayNameMobile: 'Для всех',
                    device: { desktop: true, mobile: true },
                    path: '/',
                    icon: '',
                    dropdownMenu: [
                        {
                            id: '6759450a852e8ac9d214a6bb',
                            displayName: 'Новостройки',
                            device: { desktop: true, mobile: true },
                            url: '/moskva/novostroyki/',
                            icon: 'm2-magnifier',
                        },
                        {
                            id: '6345648ac4af4b264e895b89',
                            displayName: 'Ипотека',
                            device: { desktop: true, mobile: true },
                            path: '',
                            icon: 'm2-percentage-circle',
                            exact: true,
                            dropdownMenu: [
                                {
                                    id: '64e8ad903ebc9e513bbf6d5f',
                                    displayName: 'Подать заявку',
                                    device: { desktop: true, mobile: true },
                                    path: '/ipoteka/',
                                    icon: '',
                                    exact: true,
                                },
                                {
                                    id: '64e8ada43ebc9e513bbf6d60',
                                    displayName: 'Ипотечный калькулятор',
                                    device: { desktop: true, mobile: true },
                                    path: '/ipoteka/calculator/',
                                    icon: '',
                                },
                                {
                                    id: '65705a315216331f9d89bd97',
                                    displayName: 'Ипотека на строительство дома',
                                    device: { desktop: true, mobile: true },
                                    path: '/ipoteka/stroitelstvo-doma/',
                                    icon: '',
                                    exact: true,
                                },
                                {
                                    id: '657059a15216331f9d89bd90',
                                    displayName: 'Семейная ипотека',
                                    device: { desktop: true, mobile: true },
                                    path: '/ipoteka/semeinaya-ipoteka/',
                                    icon: '',
                                    exact: true,
                                },
                                {
                                    id: '657059b35216331f9d89bd91',
                                    displayName: 'Рефинансирование ипотеки',
                                    device: { desktop: true, mobile: true },
                                    path: '/ipoteka/refinansirovanie-ipoteki/',
                                    icon: '',
                                    exact: true,
                                },
                                {
                                    id: '657059d95216331f9d89bd94',
                                    displayName: 'Ипотека с господдержкой',
                                    device: { desktop: true, mobile: true },
                                    path: '/ipoteka/lgotnaya-s-gospodderzhkoy/',
                                    icon: '',
                                    exact: true,
                                },
                                {
                                    id: '657059fa5216331f9d89bd95',
                                    displayName: 'Ипотека на первичное жильё',
                                    device: { desktop: true, mobile: true },
                                    path: '/ipoteka/na-zhile-na-pervichnom-rynke/',
                                    icon: '',
                                    exact: true,
                                },
                                {
                                    id: '65705a1a5216331f9d89bd96',
                                    displayName: 'Ипотека на вторичное жильё',
                                    device: { desktop: true, mobile: true },
                                    path: '/ipoteka/na-zhile-na-vtorichnom-rynke/',
                                    icon: '',
                                    exact: true,
                                },
                            ],
                        },
                        {
                            id: '6345651dc4af4b264e895b8c',
                            displayName: 'Сделка',
                            device: { desktop: true, mobile: true },
                            path: '/services/deal/',
                            icon: 'house-plus',
                        },
                        {
                            id: 'yuridicheskie-servisi',
                            displayName: 'Юридические сервисы',
                            device: { desktop: true, mobile: true },
                            path: '',
                            icon: '',
                            dropdownMenu: [
                                {
                                    id: 'zaschita-sdelki',
                                    displayName: 'Защита сделки',
                                    device: { desktop: true, mobile: true },
                                    path: '/services/guaranteed-deal/',
                                    icon: '',
                                },
                                {
                                    id: 'ekspress-proverka',
                                    displayName: 'Экспресс-проверка',
                                    device: { desktop: true, mobile: true },
                                    path: '/services/checkup/',
                                    icon: '',
                                },
                                {
                                    id: 'proverka',
                                    displayName: 'Проверка недвижимости',
                                    device: { desktop: true, mobile: true },
                                    path: '/services/proverka-yuridicheskoy-chistoty-kvartiry/',
                                    icon: '',
                                },
                                {
                                    id: 'konsultaciya-s-yuristom-po-nedvizhimosti',
                                    displayName: 'Консультация с юристом',
                                    device: { desktop: true, mobile: true },
                                    path: '/legal-advice/',
                                    icon: '',
                                },
                                {
                                    id: '69303be9058478f484621915',
                                    displayName: 'Подготовка ДКП',
                                    device: { desktop: true, mobile: true },
                                    path: '/services/dkp/',
                                    icon: '',
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'REALTORS',
                    displayName: 'Риелторам и агентствам',
                    displayNameMobile: 'Для профи',
                    device: { desktop: true, mobile: true },
                    path: '/rieltoram/',
                    icon: '',
                    dropdownMenu: [
                        {
                            id: '67594246852e8ac9d214a4fd',
                            displayName: 'M2Pro Новостройки',
                            device: { desktop: true, mobile: true },
                            url: '/rieltoram/m2pro-novostroyki/',
                            icon: 'm2-magnifier',
                        },
                        {
                            id: '634569648a92e72824a8807a',
                            displayName: 'Ипотека',
                            device: { desktop: true, mobile: true },
                            path: '/rieltoram/ipoteka/',
                            icon: 'm2-percentage-circle',
                        },
                        {
                            id: '634569838a92e72824a8807c',
                            displayName: 'Сделка',
                            device: { desktop: true, mobile: true },
                            path: '/rieltoram/online-sdelka/',
                            icon: 'note-sign',
                            dropdownMenu: [
                                {
                                    id: '69bd3fbd0e3ef0d914af6a4c',
                                    displayName: 'Сделки в офисе',
                                    device: { desktop: true, mobile: true },
                                    path: '/rieltoram/online-sdelka/',
                                    icon: '',
                                    exact: true,
                                },
                                {
                                    id: '69bd1b9ba68246c0293aaa05',
                                    displayName: 'Дистанционные сделки',
                                    device: { desktop: true, mobile: true },
                                    path: '/rieltoram/online-sdelka/transregional/',
                                    icon: '',
                                    exact: true,
                                },
                            ],
                        },
                        {
                            id: '6345699b8a92e72824a8807e',
                            displayName: 'Сервисы',
                            device: { desktop: true, mobile: true },
                            path: '',
                            icon: 'm2-star',
                            dropdownMenu: [
                                {
                                    id: '634569ac8a92e72824a88080',
                                    displayName: 'Сервис безопасных расчётов',
                                    device: { desktop: true, mobile: true },
                                    path: '/rieltoram/sbr/',
                                    icon: '',
                                },
                                {
                                    id: '634569bd8a92e72824a88082',
                                    displayName: 'Электронная регистрация',
                                    device: { desktop: true, mobile: true },
                                    path: '/rieltoram/elreg/',
                                    icon: '',
                                },
                                {
                                    id: '6846edae273f3de9120e3113',
                                    displayName: 'Электронная регистрация для юрлиц',
                                    device: { desktop: true, mobile: true },
                                    path: '/rieltoram/podacha-dokumentov-v-rosreestr-dlya-yul/',
                                    icon: '',
                                },
                            ],
                        },
                        {
                            id: 'yuridicheskie-servisi',
                            displayName: 'Юридические сервисы',
                            device: { desktop: true, mobile: true },
                            path: '',
                            icon: '',
                            dropdownMenu: [
                                {
                                    id: 'proverka',
                                    displayName: 'Проверка недвижимости',
                                    device: { desktop: true, mobile: true },
                                    path: '/rieltoram/proverka/',
                                    icon: '',
                                },
                                {
                                    id: 'ekspress-proverka',
                                    displayName: 'Экспресс-проверка',
                                    device: { desktop: true, mobile: true },
                                    path: '/services/checkup/',
                                    icon: '',
                                },
                                {
                                    id: 'zaschita-sdelki',
                                    displayName: 'Защита сделки',
                                    device: { desktop: true, mobile: true },
                                    path: '/rieltoram/guaranteed-deal/',
                                    icon: '',
                                },
                                {
                                    id: 'konsultaciya-s-yuristom-po-nedvizhimosti',
                                    displayName: 'Консультация с юристом',
                                    device: { desktop: true, mobile: true },
                                    path: '/legal-advice/',
                                    icon: '',
                                },
                                {
                                    id: '69303c42058478f484621942',
                                    displayName: 'Подготовка ДКП',
                                    device: { desktop: true, mobile: true },
                                    path: '/services/dkp/',
                                    icon: '',
                                },
                            ],
                        },
                        {
                            id: '63456a3e8a92e72824a8808a',
                            displayName: 'Обучение',
                            device: { desktop: true, mobile: true },
                            path: '',
                            icon: 'calendar',
                            dropdownMenu: [
                                {
                                    id: '668feeb43dd22e52f8ecc88c',
                                    displayName: 'Мероприятия',
                                    device: { desktop: true, mobile: true },
                                    path: '/events/',
                                    icon: '',
                                },
                                {
                                    id: '67c08574d688e768dce933d5',
                                    displayName: 'Тренинги и курсы',
                                    device: { desktop: true, mobile: true },
                                    path: '/rieltoram/treningi-i-kursi/',
                                    icon: '',
                                },
                            ],
                        },
                        {
                            id: 'rieltoram-rating',
                            displayName: 'Рейтинг',
                            device: { desktop: true, mobile: true },
                            path: '/rieltoram/rating/',
                            icon: '',
                        },
                        {
                            id: '691c70cc058478f484518d43',
                            displayName: 'Наши партнёры',
                            device: { mobile: true, desktop: false },
                            path: '/partners/',
                            icon: '',
                        },
                        {
                            id: '691c7107058478f484518d70',
                            displayName: 'Юридические лица',
                            device: { mobile: true, desktop: false },
                            path: '',
                            icon: '',
                            dropdownMenu: [
                                {
                                    id: '691c714b058478f484518da0',
                                    displayName: 'Изменения в регистрации сделок',
                                    device: { mobile: true, desktop: false },
                                    path: '/izmeneniya-v-elektronnoj-registracii-sdelok-yul/',
                                    icon: '',
                                },
                                {
                                    id: '691c7124058478f484518d7f',
                                    displayName: 'Электронная регистрация для юридических лиц',
                                    device: { mobile: true, desktop: false },
                                    path: '/elektronnaya-registraciya-sdelok-yul/',
                                    icon: '',
                                },
                            ],
                        },
                        {
                            id: '691c7174058478f484518dc1',
                            displayName: 'Амбассадоры',
                            device: { mobile: true, desktop: false },
                            url: 'https://am2ssador.m2.ru/',
                            icon: '',
                            target: '_blank',
                        },
                    ],
                },
                {
                    id: 'PARTNERS',
                    displayName: 'Партнёрам',
                    device: { desktop: true, mobile: false },
                    path: '/partners/',
                    icon: '',
                    dropdownMenu: [
                        {
                            id: '63456b048a92e72824a88095',
                            displayName: 'Наши партнёры',
                            device: { desktop: true, mobile: false },
                            path: '/partners/',
                            icon: '',
                        },
                        {
                            id: '67e65c81ba3ebd120718a668',
                            displayName: 'Юридические лица',
                            device: { desktop: true, mobile: false },
                            path: '',
                            icon: '',
                            dropdownMenu: [
                                {
                                    id: '67ea9e5fad77286871708fc3',
                                    displayName: 'Электронная регистрация для юридических лиц',
                                    device: { desktop: true, mobile: false },
                                    path: '/elektronnaya-registraciya-sdelok-yul/',
                                    icon: '',
                                },
                                {
                                    id: '67ea9eb0ad7728687170900c',
                                    displayName: 'Изменения в регистрации сделок',
                                    device: { desktop: true, mobile: false },
                                    path: '/izmeneniya-v-elektronnoj-registracii-sdelok-yul/',
                                    icon: '',
                                },
                                {
                                    id: '6989a64b9cfc3245b339abe9',
                                    displayName: 'Брокер ИЖС',
                                    device: { desktop: true, mobile: false },
                                    path: '/brokerizhs/',
                                    icon: '',
                                },
                            ],
                        },
                        {
                            id: '646340fecd286f0048fb0868',
                            displayName: 'Амбассадоры',
                            device: { desktop: true, mobile: false },
                            url: 'https://am2ssador.m2.ru/',
                            icon: 'lightning-circle',
                            target: '_blank',
                        },
                    ],
                },
            ],
            partners: {
                media: {
                    regionIds: [
                        9514, 23503, 40764, 6565, 171367, 123396, 741, 2025, 763, 494, 3522, 1999, 2296, 3304, 649,
                        3810, 1355, 3409, 755, 12394, 585, 958, 12064, 792, 2674231, 3273, 1201, 1302, 1332, 3845, 1959,
                        5258, 1308, 5145, 4598, 46369, 5403, 4771, 1247, 1182, 3337, 1970, 27698, 991, 3895, 1362, 706,
                        40173, 869, 1096, 2288, 2796, 677, 1259, 982, 3492, 4941, 37866, 181292, 3948, 4381, 2814,
                        30400, 59352, 1042, 169866, 4705, 1113, 22045, 2522732, 444, 886, 9513, 3, 108,
                    ],
                    id: 'media',
                    logo: 'https://cdn.m2.ru/assets/file-upload-server/66fd593306f28377fc1e190a037e930e.svg',
                    logoWhite: 'https://cdn.m2.ru/assets/file-upload-server/afa0437b1a71bb41d7a2a281edfacb42.svg',
                    url: '/media/',
                    analyticsDataClick: 'media-logo-click',
                },
            },
            personalButtons: {},
            loginPaths: {
                default: { id: 'default-login', url: '/login/' },
                client: { id: 'login-client', url: '/login/client/' },
                professional: { id: 'login-professional', url: '/login/professional/' },
                partner: { url: '/login/partner/', id: 'login-partner' },
            },
        },
    },
    navbarStore: {
        navbar: {
            menuItems: {
                CLIENT: [
                    { href: '/personal-area', icon: 'house', analytics: '', title: 'Кабинет', action: '', payload: {} },
                    {
                        href: '/personal-area/services/',
                        icon: 'm2-squares-quad',
                        analytics: '',
                        title: 'Сервисы',
                        action: '',
                        payload: {},
                    },
                    {
                        href: '',
                        icon: 'm2-chat',
                        analytics: '',
                        title: 'Чаты',
                        action: 'chat:open',
                        payload: { 'chatId:': 'chat-list' },
                    },
                ],
                PROFESSIONAL: [
                    { href: '/personal-area', icon: 'house', analytics: '', title: 'Кабинет', action: '', payload: {} },
                    {
                        href: '/personal-area/services',
                        icon: 'm2-squares-quad',
                        analytics: '',
                        title: 'Сервисы',
                        action: '',
                        payload: {},
                    },
                    {
                        href: '/personal-area/all-deals',
                        icon: 'm2-folder-clip',
                        analytics: '',
                        title: 'Заявки',
                        action: '',
                        payload: {},
                    },
                    {
                        href: '',
                        icon: 'm2-chat',
                        analytics: '',
                        title: 'Чаты',
                        action: 'chat:open',
                        payload: { 'chatId:': 'chat-list' },
                    },
                ],
                REALTOR: [
                    { href: '/personal-area', icon: 'house', analytics: '', title: 'Кабинет', action: '', payload: {} },
                    {
                        href: '/personal-area/services',
                        icon: 'm2-squares-quad',
                        analytics: '',
                        title: 'Сервисы',
                        action: '',
                        payload: {},
                    },
                    {
                        href: '/personal-area/all-deals',
                        icon: 'm2-folder-clip',
                        analytics: '',
                        title: 'Заявки',
                        action: '',
                        payload: {},
                    },
                    {
                        href: '',
                        icon: 'm2-chat',
                        analytics: '',
                        title: 'Чаты',
                        action: 'chat:open',
                        payload: { 'chatId:': 'chat-list' },
                    },
                ],
                BANK: [],
            },
        },
    },
};
